export const GET_ALL_NEWS_REQUEST = "GET_ALL_NEWS_REQUEST";
export const GET_ALL_NEWS_SUCCESS = "GET_ALL_NEWS_SUCCESS";
export const GET_ALL_NEWS_FAIL = "GET_ALL_NEWS_FAIL";

export const GET_NEWS_REQUEST = "GET_NEWS_REQUEST";
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
export const GET_NEWS_FAIL = "GET_NEWS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
